import Vue from 'vue';
import brandsTargetingUrls from '../../../../../urls/brandsTargetingUrls';
import debounce from '../../../../../helpers/debounce';

let brandsDebounceFunc = null;
let loadedBrandsModels = [];

function loadBrandsModels() {

    if (loadedBrandsModels.length === 0) {

        loadedBrandsModels = ((typeof (model) !== "undefined" && typeof (model.all_brands_models) !== "undefined") ? model.all_brands_models : []).flatMap((a) => {

            let parent_id = btoa(g_toUTF8Array(a.brand).join('-'));

            let children = a.models.map((b) => {

                return {
                    id: b.counter,
                    parent: parent_id,
                    name: b.model,
                    parentDesc: b.brand,
                    type: 2,
                    typeName: 'Model',
                    selected: false
                };

            });

            let parent = {
                id: parent_id,
                name: a.brand,
                type: 1,
                typeName: 'Brand',
                showChildren: false,
                selected: false,
                children: children,
                childrenCount: a.models.length
            };

            return [parent, ...children];
        })

    }

    return loadedBrandsModels;
        
}

const state = {

    // -------- Brands -------
    searchingBrands: false,

    initialBrandsModels: (() => {
        return loadBrandsModels();
    })(),

    brandsModels: (() => {

        let temp = loadedBrandsModels;
        let iosBrands = ["iPhone", "iPad", "iPod", "iOS-Device"].map(b => b.toLowerCase());
        let _bm = temp.filter(d => model.camp_platform_id == 1
            ? (iosBrands.indexOf(d.name.toLowerCase()) < 0)
            : (iosBrands.indexOf(d.name.toLowerCase()) > -1));
        return _bm;

    })(),


    searchBrandsModels: [],

    brandsModelsTree: null,

    showBrandsModelsTree: true,

    includedModelsDevicesArray: [],
    excludedModelsDevicesArray: [],

    brandsRadioButtonOption: (() => {

        try {
            return model && model.currentCampaignObj.brands_audience_to_save.inc && model.currentCampaignObj.brands_audience_to_save.inc.length > 0 ? 2 : 1;
        } catch (e) {
            return 1;
        }

    })()
};

const getters = {

    // -------- Brands -------
    searchingBrandsModels(state) {
        return state.searchingBrandsModels;
    },

    showBrandsModelsTree(state) {
        return state.showBrandsModelsTree;
    },

    brandsModels(state) {
        return state.brandsModels;
    },

    searchBrandsModels(state) {
        return state.searchBrandsModels;
    },

    brandsModelsTree(state) {

        if (!state.showBrandsModelsTree) {
            return state.searchBrandsModels;
        }

        if (state.brandsModelsTree)
            return state.brandsModelsTree;

        let treeify = function (list, idAttr, parentAttr, childrenAttr) {
            if (!idAttr) idAttr = 'id';
            if (!parentAttr) parentAttr = 'parent';
            if (!childrenAttr) childrenAttr = 'children';
            var treeList = [];
            var lookup = {};
            list.forEach(function (obj) {
                lookup[obj[idAttr]] = obj;
                obj[childrenAttr] = [];
            });
            list.forEach(function (obj) {
                if (obj[parentAttr] != null) {
                    lookup[obj[parentAttr]][childrenAttr].push(obj);
                } else {
                    treeList.push(obj);
                }
            });
            return treeList;
        };

        // build tree from the brandsModels

        let iosBrands = ["iPhone", "iPad", "iPod", "iOS-Device"].map(b => b.toLowerCase());

        let _bm = state.initialBrandsModels.filter(d => model.camp_platform_id == 1
            ? (iosBrands.indexOf(d.name.toLowerCase()) < 0)
            : (iosBrands.indexOf(d.name.toLowerCase()) > -1));

        state.brandsModelsTree = treeify(_bm);

        return state.brandsModelsTree;

    },

    includedModelsDevices(state) {

        return state.includedModelsDevicesArray;
    },

    excludedModelsDevices(state) {

        return state.excludedModelsDevicesArray;
    },

    selectedBrandsRadioButton(state) {

        return state.brandsRadioButtonOption;
    },

    // --------------------------

};

const mutations = {

    // -------- Locations -------
    setIncExcBrandsDevicesArrays(state, item) {

        if (item) {

            if (!item.parent) {  // item is a parent

                let other_included = state.includedModelsDevicesArray.filter(c => c.parent !== item.id && c.id !== item.id);
                let other_excluded = state.excludedModelsDevicesArray.filter(c => c.parent !== item.id);

                let children = item.children;
                let selected = item.children.filter(c => c.selected);

                if (children.length === selected.length) {
                    state.includedModelsDevicesArray = [...other_included, item];
                    state.excludedModelsDevicesArray = [...other_excluded];
                }
                else if (selected.length == 0) {
                    state.includedModelsDevicesArray = other_included;
                    state.excludedModelsDevicesArray = other_excluded;
                }

            }
            else {

                let parent = state.brandsModels.find(c => c.id == item.parent);
                let children = parent.children;
                let selected = parent.children.filter(c => c.selected);

                let other_included = state.includedModelsDevicesArray.filter(c => c.parent !== item.parent && c.id !== item.parent);
                let other_excluded = state.excludedModelsDevicesArray.filter(c => c.parent !== item.parent);

                if (children.length === selected.length) {
                    state.includedModelsDevicesArray = [...other_included, parent];
                    state.excludedModelsDevicesArray = other_excluded;
                }
                else if (selected.length == 0) {
                    state.includedModelsDevicesArray = other_included;
                    state.excludedModelsDevicesArray = other_excluded;
                }
                else {

                    let indexInc = state.includedModelsDevicesArray.findIndex(c => c.id === item.id);
                    let indexExc = state.excludedModelsDevicesArray.findIndex(c => c.id === item.id);

                    if (parent.selected) {

                        if (item.selected) {
                            if (indexExc > -1)
                                state.excludedModelsDevicesArray.splice(indexExc, 1);
                        }
                        else {
                            if (indexExc < 0)
                                state.excludedModelsDevicesArray = [...state.excludedModelsDevicesArray, item];
                        }

                    }
                    else { // parent not selected

                        if (item.selected) {
                            if (indexInc < 0)
                                state.includedModelsDevicesArray = [...state.includedModelsDevicesArray, item];
                        }
                        else {
                            if (indexInc > -1)
                                state.includedModelsDevicesArray.splice(indexInc, 1);
                        }
                    }
                }
            }


            state.includedModelsDevicesArray.map((loc) => {

                if (!loc.parent) {
                    loc.children.map((child) => {

                        if (state.excludedModelsDevicesArray.findIndex(x => x.id === child.id) > -1)
                            child.selected = false;
                        else
                            child.selected = true;

                    });
                }

            });


            state.brandsModelsTree.filter(s => s.selected).map((loc) => {

                loc.children.map((child) => {

                    if (state.excludedModelsDevicesArray.findIndex(x => x.id === child.id) > -1)
                        child.selected = false;
                    else
                        child.selected = true;

                });

            });


            let inc = (state.includedModelsDevicesArray || []).map(x => encodeURIComponent(x.typeName) + ":" + (x.type == 1 ? encodeURIComponent(x.name) : encodeURIComponent(x.id))).join();
            let exc = (state.excludedModelsDevicesArray || []).map(x => encodeURIComponent(x.typeName) + ":" + (x.type == 1 ? encodeURIComponent(x.name) : encodeURIComponent(x.id))).join();
            let incexc = { inc, exc };

            model.currentCampaignObj.brands_audience_to_save = incexc;

        }
    },

    selectBrandModel(state, item) {

        if (item) {


            (item.children || []).filter(c => item.selected !== c.selected).map((c) => {
                c.selected = item.selected;
            });

            let m = state.brandsModels.find(c => c.id == item.id);

            if (!item.parent) {  // if item is parent

                m.selected = item.selected;

                m.children.filter(c => item.selected !== c.selected).map((c) => {
                    c.selected = item.selected;
                });
                if (this.getters.selectedBrandsRadioButton === 1) {
                    if (_isAdmin) { window.appCampaignDoughnut.$emit('calcChartRates'); }
                }
            }
            else { // item is a child

                m.selected = item.selected;

                let parent = state.brandsModels.find(c => c.id == item.parent);
                let pch = parent.children.find(c => c.id == m.id);
                pch.selected = item.selected;

                let children = parent.children;
                let selected = parent.children.filter(c => c.selected);

                if (children.length === selected.length) {
                    parent.selected = true;
                }
                else if (selected.length == 0) {
                    parent.selected = false;
                }
                if (this.getters.selectedBrandsRadioButton === 1) {
                    if (_isAdmin) { window.appCampaignDoughnut.$emit('calcChartRates'); }
                }
            }
        }
    },

    searchBrandModel(state, searchString) {

        state.searchingBrandsModels = true;

        let arr = [];
        let term = (searchString || "").toLowerCase().trim();
        arr = state.brandsModels.filter(m => m.name.toLowerCase().indexOf(term) > -1 || (m.hasOwnProperty("parentDesc") ? m.parentDesc.toLowerCase().indexOf(term) > -1 : false));

        state.searchBrandsModels = [...arr];

        state.searchBrandsModels.filter(m => m.hasOwnProperty("parentDesc")).forEach((a) => {

            let b = state.brandsModels.find(c => c.id == a.id);
            a.selected = b.selected;
            
        })

        state.searchingBrandsModels = false;
        state.showBrandsModelsTree = false;

   },

    searchBrandModelOnServer(state, payload) {

        if (brandsDebounceFunc) {
            brandsDebounceFunc(payload);
            return;
        }

        brandsDebounceFunc = debounce((searchString) => {

            state.searchingBrandsModels = true;

            Vue.$http.post(brandsTargetingUrls.getBrandsDevices, { term: searchString }).then((response) => {
                const data = response.data;
                if (!data || data.length == 0) {
                    return;
                }

                let arr = [];

                let idx = 0;
                data.flatMap(({ brand, models }) => {

                    let location = null;

                    let _brand = state.brandsModels.find(l => !l.parent && l.name === brand);

                    let parent_id = btoa(g_toUTF8Array(brand).join('-'));

                    let children = models.map((m) => {

                        return {
                            id: m.counter,
                            parent: parent_id,
                            name: m.model,
                            parentDesc: m.brand,
                            type: 2,
                            typeName: 'Model',
                            selected: false
                        };

                    });

                    // let children = [];

                    let parent = {
                        id: parent_id,
                        name: brand,
                        type: 1,
                        typeName: 'Brand',
                        showChildren: false,
                        selected: false,
                        children: children,
                        childrenCount: children.length
                    };

                    arr = [ ...arr, parent];

                });

            
                state.searchBrandsModels = arr;
                state.searchingBrandsModels = false;
                state.showBrandsModelsTree = false;

            }).catch((error) => {

            });

        });

        brandsDebounceFunc(payload);

    },

    clearBrandsModelsSearch() {

        state.searchingBrandsModels = false;
        state.showBrandsModelsTree = true;

    },

    SET_selectedBrandsRadioButton(state, selectedOption) {
        state.brandsRadioButtonOption = selectedOption;
        model.currentCampaignObj.selectedBrandsRadioButton = selectedOption;
        cmGlobalScope.brands_selection_is_valid = !(selectedOption == 2 && (model.currentCampaignObj.brands_audience_to_save === null || model.currentCampaignObj.brands_audience_to_save === undefined || model.currentCampaignObj.brands_audience_to_save.inc.length === 0));
    },

    setBrandModelsMutation(state) {
        
        let initbm = this.getters.initialBrandsModels;

        state.brandsModels = [];

        let iosBrands = ["iPhone", "iPad", "iPod", "iOS-Device"].map(b => b.toLowerCase());

        let _bm = initbm.filter(d => model.camp_platform_id == 1
            ? (iosBrands.indexOf(d.name.toLowerCase()) < 0)
            : (iosBrands.indexOf(d.name.toLowerCase()) > -1));

        _bm.map((c) => {
            state.brandsModels.push(c);
        });

    }

};

const actions = {

    // -------- Locations -------
    searchBrandModel(context, payload) {
        context.commit('searchBrandModel', payload);
    },

    saveIncExcListsToServer(context, payload) {
        // make a server post to save lists as string to DB
        localStorage['brandsSave'] = JSON.stringify(payload);
        model.currentCampaignObj.brands_audience_to_save = payload;
        model.currentCampaignObj.selectedBrandsRadioButton = this.getters.selectedBrandsRadioButton;

        cmGlobalScope.brands_selection_is_valid = !(this.getters.selectedBrandsRadioButton === 2 && (model.currentCampaignObj.brands_audience_to_save === undefined || model.currentCampaignObj.brands_audience_to_save === null || model.currentCampaignObj.brands_audience_to_save.inc.length == 0));

        if (this.getters.selectedBrandsRadioButton === 1) {
            if (_isAdmin) { window.appCampaignDoughnut.$emit('calcChartRates'); }
        }
    },

    updateBrands(context, payload) { 

        let _selectedBrandsRadioButton = payload;
        let inc_exc_list = _selectedBrandsRadioButton === 2 && model.currentCampaignObj.brands_audience_to_save ? model.currentCampaignObj.brands_audience_to_save : { inc: "", exc: "" };

        if (_selectedBrandsRadioButton == 1) {

            state.brandsModels.forEach((item) => {

                if (!item.parent) {  // if item is parent

                    item.selected = false;

                    item.children.forEach((ch) => {
                        ch.selected = false;
                    });
                }
                else { // item is a child
                    item.selected = false;
                }

            });

        }

        let excs = (inc_exc_list.exc == "" ? [] : inc_exc_list.exc.split(',')).map((kv) => {

            let id = parseInt(kv.split(':')[1]);
            let loc = JSON.parse(JSON.stringify(state.initialBrandsModels.find(l => l.id === id)));
            loc.selected = false;

            return loc;

        }) || [];

        let incs = (inc_exc_list.inc == "" ? [] : inc_exc_list.inc.split(',')).map((kv) => {

            let sp = kv.split(':');
            let type = sp[0], uniq = sp[1];
            if (type.toLowerCase() == 'brand') {

                let loc = JSON.parse(JSON.stringify(state.initialBrandsModels.find(l => l.name === uniq)));
                loc.selected = true;

                // apply exclude also to parent's children
                let excluded_children_ids = excs.map(c => c.id);
                loc.children.map((ch) => {
                    if (excluded_children_ids.indexOf(ch.id) > -1)
                        ch.selected = false;
                    else
                        ch.selected = true;
                });

                return loc;
            }
            else {

                let loc = JSON.parse(JSON.stringify(state.initialBrandsModels.find(l => l.id === parseInt(uniq))));
                loc.selected = true;

                return loc;
            }

        }) || [];


        excs.map((x) => {
            let item = state.brandsModels.find(c => c.id == x.id);
            if (typeof item !== 'undefined') {
                item.selected = false;
            }
        });

        incs.map((x) => {

            let item = state.brandsModels.find(c => c.id == x.id);

            if (typeof item !== 'undefined') {
                item.selected = true;

                if (!item.parent) {  // item is a parent

                    item.children.map((child) => {

                        if (excs.findIndex(c => c.id === child.id) > -1) {
                            child.selected = false;
                            let itm = state.brandsModels.find(c => c.id == child.id);
                            itm.selected = false;
                        }
                        else
                            child.selected = true;

                    });

                }
            }
        });

        state.includedModelsDevicesArray = incs;
        state.excludedModelsDevicesArray = excs;

        cmGlobalScope.brands_selection_is_valid = !(_selectedBrandsRadioButton === 2 && (model.currentCampaignObj.brands_audience_to_save === undefined || model.currentCampaignObj.brands_audience_to_save === null || model.currentCampaignObj.brands_audience_to_save.inc.length == 0));
    }, 

    setSelectedBrandsRadioButton({ commit }, newValue) {
        commit("SET_selectedBrandsRadioButton", newValue);
    },

    setBrandModels({ commit }, newValue) {
        commit("setBrandModelsMutation", newValue);
    }

};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/components/Campaign/Targeting/Brands/store/brandsStore.js